
const initialState = {
    vendedor:{
        active: '',
        list: ['Angela', 'Maria'],
        dados: 'teste',
        nome: '',
        endereco: '',

    }
}



const vendedorReducer = (state = initialState.vendedor, action) => {
    if(action.type === 'CHANGE_VENDEDOR'){
       return {
           ...state,
           active: action.payload
       }
    }else if(action.type === 'CHANGE_VENDEDOR_DADOS'){
        return {
            ...state,
            dados: action.payload[0],
            nome: action.payload[1]
        }
     }
    return state;

}

export default vendedorReducer;
